export interface CellActions {
  endEdit: () => void;
  startEdit: () => void;
  focus: () => void;
  setDelegateEditState: (value: boolean) => void;
  onEdited: (columnsDef?: string[]) => void;
}
